<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 199"><path d="m349.13 3.79h40.82v191.41h-40.82z"/><path d="m181.58 3.79h40.82v191.41h-40.82z"/><path d="m425.01 99.5h-40.82l64.48-95.71h40.81z"/><path d="m463.75 129.22h-40.81l45.21 65.99h40.82z"/><path d="m326.42 72.57c0-37.83-30.95-68.78-68.78-68.78h-18.73v38.76h18.73c7.94 0 15.46 3.14 21.16 8.85 5.71 5.71 8.85 13.22 8.85 21.16 0 7.94-3.14 15.46-8.85 21.16-5.71 5.71-13.22 8.85-21.16 8.85h-18.73v38.76h18.73c37.83.01 68.78-30.94 68.78-68.76"/><path d="m89.72 37.38c18.42 1.69 27.23 11.99 29.45 26.84h38.78c-3.95-43.46-38.7-57.9-68.23-60.14v33.3"/><path d="m101.01 85.37l-22.78-4.61c-16.81-3.25-26.03-8.68-26.03-21.15 0-11.42 8.07-18.89 21.04-21.48v-34.08c-37.83 2.79-62.52 25.58-62.52 58.82 0 28.74 16 46.91 52.6 54.23l30.1 5.7c18.71 3.52 23.05 11.39 23.05 18.98 0 12.47-10.85 19.79-30.37 19.79-24.67 0-40.94-11.66-43.93-30.37h-39.05c3.26 41.21 36.34 64.8 80.81 64.8 44.2 0 73.21-23.32 73.21-58.57 0-30.91-20.88-44.47-56.13-52.06"/></svg>
</template>

<script>
export default {
  name: 'spk-logo'
}
</script>



// WEBPACK FOOTER //
// SpkLogo.vue?dd3f2104